/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Reordered1Inputs */

const vi_guidevideo_reordered1 = /** @type {(inputs: Guidevideo_Reordered1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thứ tự video.`)
};

/**

* @param {Guidevideo_Reordered1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_reordered1 = /** @type {((inputs?: Guidevideo_Reordered1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Reordered1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_reordered1(inputs)
});
export { guidevideo_reordered1 as "guideVideo_reordered" }